export const getImageUrl = async (url: string) => {
    return url;
}